<template>
    <div>
        <h3 class="text-center">รายงานใบกำกับภาษี (excel)</h3>
        <br>
        <div class="row form-group">
            <div class="col-5">
                เดือนที่ต้องการออกรายงาน
            </div>
            <div class="col-6">
                <date-picker
                    v-model="print.month"
                    type="month"
                    format="MM/YYYY"
                    :lang="lang"
                    class="w-100"
                    confirm
                    placeholder="เลือกเดือน">
                </date-picker>
            </div>
        </div>
        <div class="col text-center mt-3">
            <button type="button" class="btn btn-success" @click="submitData">
                <icon name="save"></icon>
                บันทึก
            </button>
            &nbsp;&nbsp;
            <button type="button" class="btn btn-outline-secondary" @click="cancelData">
                <icon name="times"></icon>
                ยกเลิก
            </button>
        </div>
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import moment from "moment";

export default {
    name: "export-excel-modal",
    components: {
        DatePicker,
    },
    data() {
        return {
            print: {
                month: "",
            },
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        }
    },
    methods: {
        cancelData() {
            this.$emit('submit', false);
            this.print = {
                month: "",
            }
        },
        submitData() {
            this.$emit('submit', this.print.month);
            this.print = {
                month: "",
            }
        }
    }
}
</script>

<style scoped>

</style>
